import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'

const StyledLink = styled(Link)`
  margin-bottom: 10px;
  position: relative;
  left: 14px;
  display: block;
  width: calc(100% - 14px);
  &:before {
    display: block;
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    top: 7px;
    left: -14px;
    border-left: 8px solid #3ec7b3;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
  }
  h2 {
    font-size: 16px;
    font-weight: 400;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    color: #505050;
    transition: 0.3s all;
  }
  span {
    color: #ababab;
  }
  &:hover {
    text-decoration: underline solid rgba(255, 255, 255, 0);
    h2 {
      text-decoration: underline solid #3abd9e;
      color: #00b5a6;
    }
  }
`

type Props = {
  /** クラス名 */
  className?: string
  /** リンク先 */
  href: string
  /** タイトル */
  label: string
  /** 日付 */
  date: string
}

/**
 * コラムサイドバー用リストリンクコンポーネント
 * @param props
 * @constructor
 */
const ColumnSideLink = (props: Props): JSX.Element => {
  const { className = '' } = props

  return (
    <StyledLink className={className} to={props.href}>
      {/** TODO 記事のタイトルがここに表示されます */}
      <h2>{props.label}</h2>
      {/** TODO 川上申し送り事項：▼記事の投稿日がここに表示されます */}
      <span>{props.date}</span>
    </StyledLink>
  )
}

export default ColumnSideLink
